import { Controller } from "@hotwired/stimulus"
import { template } from "lodash"
import { parseNumber, formatNumber } from "./../helpers"

// Kontener sekcji rozliczenia KSeF (obciążenia/odliczenia) — dodawanie wierszy, toggle całej
// sekcji, przeliczanie sum, synchronizacja waluty faktury
export default class extends Controller {
  static targets = ["checkbox", "body", "chargesContainer", "deductionsContainer", "chargesSum", "deductionsSum",
    "chargeTemplate", "deductionTemplate", "currencyLabel"]

  static values = {
    currency: String,
    locale: String,
    chargesIndex: Number,
    deductionsIndex: Number
  }

  static outlets = ["invoice--settlement-position"]

  connect() {
    if (this.hasChargeTemplateTarget) this.chargeTemplateFn = template(this.chargeTemplateTarget.innerHTML)
    if (this.hasDeductionTemplateTarget) this.deductionTemplateFn = template(this.deductionTemplateTarget.innerHTML)

    // Synchronizuj widoczność z checkboxem (przeglądarka może zapamiętać stan po odświeżeniu)
    if (this.hasCheckboxTarget && !this.checkboxTarget.checked) {
      this._toggleSettlements(false)
    } else {
      this.updateSums()
    }
    window.addEventListener("currency-changed", this.onCurrencyChanged = (event) => {
      this.currencyValue = event.detail.currency
    })
  }

  disconnect() {
    window.removeEventListener("currency-changed", this.onCurrencyChanged)
  }

  toggle(event) {
    this._toggleSettlements(event.target.checked)
  }

  _toggleSettlements(checked) {
    this.bodyTarget.classList.toggle("hidden", !checked)

    if (checked) {
      this.invoiceSettlementPositionOutlets.forEach(row => row.restoreIfMarkedForDestroy())
    } else {
      this.invoiceSettlementPositionOutlets.forEach(row => row.remove())
    }

    this.updateSums()
  }

  addCharge() {
    this.addRow(this.chargeTemplateFn, this.chargesContainerTarget, this.chargesIndexValue)
    this.chargesIndexValue += 1
    this.updateSums()
  }

  addDeduction() {
    this.addRow(this.deductionTemplateFn, this.deductionsContainerTarget, this.deductionsIndexValue)
    this.deductionsIndexValue += 1
    this.updateSums()
  }

  updateSums() {
    const chargesSum = this.sumAmounts(this.chargesContainerTarget)
    const deductionsSum = this.sumAmounts(this.deductionsContainerTarget)

    if (this.hasChargesSumTarget) {
      this.chargesSumTarget.textContent = this.formatSum(chargesSum)
      this.chargesSumTarget.closest("[data-settlement-sum]")?.classList.toggle("hidden", chargesSum === 0)
    }
    if (this.hasDeductionsSumTarget) {
      this.deductionsSumTarget.textContent = this.formatSum(deductionsSum)
      this.deductionsSumTarget.closest("[data-settlement-sum]")?.classList.toggle("hidden", deductionsSum === 0)
    }
  }

  currencyValueChanged(value) {
    this.currencyLabelTargets.forEach(el => { el.textContent = value })
    this.invoiceSettlementPositionOutlets.forEach(row => { row.currencyValue = value })
  }

  addRow(templateFn, container, index) {
    const html = templateFn({ index, currency: this.currencyValue })
    container.insertAdjacentHTML("beforeend", html)
  }

  sumAmounts(container) {
    let sum = 0
    container.querySelectorAll("[data-settlement-row]:not(.hidden) .settlement-amount").forEach(input => {
      const val = parseNumber(input.value, { locale: this.localeValue })
      if (!isNaN(val)) sum += val
    })
    return Math.round(sum * 100) / 100
  }

  formatSum(val) {
    return formatNumber(val, { locale: this.localeValue, app_digits: 2 })
  }
}
